<template>
    <app-layout title="ModuleEdit">

        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Tenants
            </h2>
        </template>

      <PageTitle :headerTitle="title"> </PageTitle>









        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    
                    
                    <form class="form-horizontal" @submit.prevent="submit" >

                            <div>
                                <div class="pull-right">
                                    <input type="submit" value="Save" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" />
                                    <a href="#" id="deploy" disabled class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Deploy</a>
                                    <a href="#" disabled class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Export</a>
                                    <a href="#" disabled class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Duplicate</a>
                                    <a href="#" disabled class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Delete</a>
                                </div><br>    
                            </div> <!-- /end buttons -->
                        
                           
                        <BsEdit :createDef="createDef" :routeDef="moduleRoute" ref="formRenderer">

                        </BsEdit>
                           
                            
                    </form>


                </div>
            </div>
        </div>

    </app-layout>
</template>

<script>
    
import AppLayout from '@/Layouts/AppLayout.vue'
import BsEdit from '@/Base/BsEdit.vue';
import PageTitle from "@/Layouts/PageTitle.vue";


let collapsed = false;

    export default {
        props: {      
            createDef:Array,    
            moduleRoute:String,
        },
        components: {
            AppLayout,
            BsEdit,
            PageTitle,
        },
        
  data() {
    return {
      title: "Edit Module",
    }
  },
    methods: {
        sayHelloWorld() {
            alert('Hello world!')
        },
        submit()
        {
            this.$inertia.post('/'+this.moduleRoute, this.$refs.formRenderer.formData);
        }
    },
        mounted() {
          
        
        }
    }
</script>
